import { connect } from 'react-redux';
import type { NavigateFunction } from 'react-router';
import { isInvalid, isSubmitting, submit } from 'redux-form';

import type { Dispatch, State } from '../../../types';
import { submitEditGeofence } from '../../actions/geofenceActions';
import { showNotification } from '../../actions/notificationActions';
import { showDeletePOIDialog } from '../../actions/poiActions';
import { Routing } from '../../app/Routing';
import type { FunctionProperties, NonFunctionProperties } from '../../utils/typescriptutils/typeManipulation';
import { geofenceFormElements } from './GeofenceForm';
import { type GeofenceCreationSidebarProps, GeofenceSidebar } from './GeofenceSidebar';

export const mapStateToProps = (state: State): NonFunctionProperties<GeofenceCreationSidebarProps> => {
    const submitDisabled =
        isInvalid(geofenceFormElements.geofenceFormName)(state) ||
        isSubmitting(geofenceFormElements.geofenceFormName)(state);

    return {
        submitDisabled,
        mode: 'UPDATE' as const,
    };
};

export const mapDispatchToProps = (dispatch: Dispatch): FunctionProperties<GeofenceCreationSidebarProps> => ({
    autofillFromQueryString(): void {},
    onDelete: (geofenceId: string) => {
        dispatch(showDeletePOIDialog(geofenceId));
    },
    onClose: (navigate: NavigateFunction) => {
        navigate(Routing.poiList);
    },
    onSubmitForm: (navigate: NavigateFunction) =>
        dispatch(submitEditGeofence())
            .then(() => navigate(Routing.poiList))
            .then(() => dispatch(showNotification('intl-msg:geofence.edit.successNotification', 'success')))
            .catch(() => dispatch(showNotification('intl-msg:geofence.edit.errorNotification', 'error'))),
    onClickSubmit: () => dispatch(submit(geofenceFormElements.geofenceFormName)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GeofenceSidebar);
